export default "__VITE_ASSET__VjMGJfkq__"